@if (filterForm != null) {
    <h2 class="expand-header" [class.expanded]="this.filterForm().expanded().value()" (click)="toggleExpanded()">Eieform</h2>

    <div class="expander ownershipTypes" [class.expanded]="this.filterForm().expanded().value()">
        <div class="container">
            <div class="left">
                <ul>
                    @for (ownershipType of this.filterForm().ownershipTypes; track $index) {
                        <li class="check-box" (click)="toggleSelectedOwnership(ownershipType().value())">
                            <input
                                type="checkbox"
                                class="checkbox-icon"
                                [formField]="ownershipType.selected"
                                [class.selected]="ownershipType.selected().value()"
                            />
                            <label> {{ ownershipType.displayText().value() }} </label>
                        </li>
                    }
                </ul>
            </div>
            <div class="right">
                <div class="select-all-btn" data-cy="click-all" (click)="selectAllOwnershipTypes()">
                    <label>Alle</label>
                </div>
            </div>
        </div>
    </div>
}
